import types from './types/index';
export * from './types/index'; // Tentative API
// Data: {
//   // UI
//   Grid,
//   Filter,
//   // render prop
//   Item,
//   List
//   // hooks
//   useItem,
//   useCollection,
//   useActions,
//   // contact = Data.useItem('contact', 57)
//   // contact.value.Id == 57
//   // contact.meta.loading
//   // contact.actions.delete({ useConfirmation })
//   // interactions = Data.useList('engagementInteraction')
//   // interactions.value[0]
//   // imperative api
//   action: {
//     item: (id) => {
//       fetch
//     },
//     list
//     grid
//   },
//   TYPES,
// }

export default types;